export enum TabOptions {
  Create = 'Create',
  ScheduledJobs = 'Scheduled Jobs',
  JobHistory = 'Job History'
};